import { useState } from 'react';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/bundle';
import './HomeBanner.scss';

interface BannerSlide {
  url: string;
  caption: string | null;
  imageUrl: string;
  isImage: boolean;
}

interface HomeBannerProps {
  slides: BannerSlide[];
  prevArrowUrl: string;
  nextArrowUrl: string;
}

export default function HomeBanner({
  slides,
  prevArrowUrl,
  nextArrowUrl,
}: HomeBannerProps) {
  const [prevEl, setPrevEl] = useState<HTMLDivElement | null>(null);
  const [nextEl, setNextEl] = useState<HTMLDivElement | null>(null);

  return (
    <div className="home-banner">
      <div className="banner-arrow banner-arrow--prev" ref={setPrevEl}>
        <img src={prevArrowUrl} alt="Previous" />
      </div>
      <div className="banner-arrow banner-arrow--next" ref={setNextEl}>
        <img src={nextArrowUrl} alt="Next" />
      </div>

      <Swiper
        className="banner"
        modules={[Autoplay, Navigation]}
        slidesPerView={1}
        speed={300}
        loop={true}
        autoplay={{
          delay: 8000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }}
        navigation={{ prevEl, nextEl }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            {slide.caption && (
              <div className="caption">
                <p>{slide.caption}</p>
              </div>
            )}
            <a href={slide.url} className="banner-container">
              {slide.isImage ? (
                <img src={slide.imageUrl} className="banner-image" alt="" />
              ) : (
                <video
                  src={slide.imageUrl}
                  className="video-banner"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              )}
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
